/**
 * Formulario para crear/editar sucursales
 */
import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, Space, message, Row, Col } from "antd";
import api from "../../api/endpoints";

const BranchForm = ({ visible, branch, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      if (branch) {
        form.setFieldsValue(branch);
      } else {
        form.resetFields();
      }
    }
  }, [visible, branch, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      // Validar formulario antes de continuar
      try {
        await form.validateFields();
      } catch (error) {
        message.error("Por favor completa todos los campos requeridos");
        setLoading(false);
        return;
      }

      console.log(`${branch ? "Actualizando" : "Creando"} sucursal con datos:`, values);

      if (branch) {
        const updated = await api.branches.update(branch.id, values);
        console.log("Sucursal actualizada exitosamente:", updated);
        message.success("Sucursal actualizada exitosamente");
      } else {
        const created = await api.branches.create(values);
        console.log("Sucursal creada exitosamente:", created);
        message.success("Sucursal creada exitosamente");
      }
      form.resetFields();
      
      // Pequeño delay para asegurar que localStorage se actualice
      setTimeout(() => {
        onSuccess();
      }, 100);
    } catch (error) {
      console.error(`Error al ${branch ? "actualizar" : "crear"} sucursal:`, error);
      message.error(
        `Error al ${branch ? "actualizar" : "crear"} sucursal: ${
          error.message || "Error desconocido"
        }`
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={branch ? "Editar Sucursal" : "Nueva Sucursal"}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width="95%"
      style={{ maxWidth: 700 }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              name="business_name"
              label="Nombre Comercial"
              rules={[{ required: true, message: "El nombre es requerido" }]}
            >
              <Input placeholder="Ej: Bizantino Gelato - Sucursal Centro" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12}>
            <Form.Item
              name="commercial_business"
              label="Giro Comercial"
              rules={[{ required: true, message: "El giro es requerido" }]}
            >
              <Input placeholder="Ej: Heladería Artesanal" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              name="phone"
              label="Teléfono"
              rules={[{ required: true, message: "El teléfono es requerido" }]}
            >
              <Input placeholder="56912345678" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="dni"
              label="RUT"
              rules={[{ required: true, message: "El RUT es requerido" }]}
            >
              <Input placeholder="76.123.456-7" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="email"
              label="Email"
              rules={[
                { required: true, message: "El email es requerido" },
                { type: "email", message: "Email inválido" },
              ]}
            >
              <Input placeholder="sucursal@bizantinogelato.cl" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              name="region"
              label="Región"
              rules={[{ required: true }]}
            >
              <Input placeholder="Región Metropolitana" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="province"
              label="Provincia"
              rules={[{ required: true }]}
            >
              <Input placeholder="Santiago" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="commune"
              label="Comuna"
              rules={[{ required: true }]}
            >
              <Input placeholder="Santiago" />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item
          name="address"
          label="Dirección"
          rules={[{ required: true }]}
        >
          <Input placeholder="Av. Providencia 1234" />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button onClick={onCancel}>Cancelar</Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {branch ? "Actualizar" : "Crear"}
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BranchForm;

